module.exports = __webpack_public_path__ + "static/media/fansfirst-logo.857acbad.svg";